<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.save()"
        extra-large
        ref="RkmModal"
        title="Cadastro de convênio médico"
    >
        <Form
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {Form},
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-convenio-medico-form')
        },
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit(convenioMedico) {
            this.$emit('save', convenioMedico)
            this.$refs.RkmModal.hide()
        },
    }
}
</script>